/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Installment { 
    id?: number;
    installmentNumber?: number;
    amount?: number;
    dueDate?: string;
    paidAt?: string;
    transactionId?: string;
    paymentMethod?: string;
    authorizationCode?: string;
    notes?: string;
    status?: Installment.StatusEnum;
    createdAt?: string;
    updatedAt?: string;
    cancelledAt?: string;
    cancelled?: boolean;
    overdue?: boolean;
}
export namespace Installment {
    export type StatusEnum = 'PENDING_PAYMENT' | 'PAID' | 'LATE' | 'CANCELLED_PAYMENT' | 'CANCELLED';
    export const StatusEnum = {
        PendingPayment: 'PENDING_PAYMENT' as StatusEnum,
        Paid: 'PAID' as StatusEnum,
        Late: 'LATE' as StatusEnum,
        CancelledPayment: 'CANCELLED_PAYMENT' as StatusEnum,
        Cancelled: 'CANCELLED' as StatusEnum
    };
}


